import React, { useState } from 'react';
import SubPlayer from './sub-player';

interface IProps {
    videoId: string;
    auto?: boolean; // 是否播放
}

const VideoPlayer: React.FC<IProps> = props => {
    console.log('🚀 ~ props:', props);
    const [isPlay, setIsPlay] = useState(false);
    return isPlay ? (
        <SubPlayer videoId={props.videoId} />
    ) : (
        <img
            onClick={() => setIsPlay(true)}
            src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202311/24/a5c72_20231124133303.png"
        />
    );
};

export default VideoPlayer;
